import { useAppState } from '../../client/providers/AppProvider';
import React from 'react';
import { usePageRequireAuth } from '../../client/hooks';
import { DashboardFullPageLoading } from '../../components/common/GenericFullPageLoading';
import { FullPageComingSoon } from '../../components/sections/FullPageComingSoon';
import { DashboardLayout } from '../../components/common/layout/DashboardLayout';

export default function BadgesPage() {
    const { user } = useAppState();
    usePageRequireAuth({});
    if (!!!user) {
        return <DashboardFullPageLoading />;
    }

    return (
        <DashboardLayout pageTitle="Badges">
            <FullPageComingSoon />
        </DashboardLayout>
    );
}
